import { render, staticRenderFns } from "./pageDiagnosis2.vue?vue&type=template&id=4821b454&scoped=true"
import script from "./pageDiagnosis2.vue?vue&type=script&lang=js"
export * from "./pageDiagnosis2.vue?vue&type=script&lang=js"
import style0 from "./pageDiagnosis2.vue?vue&type=style&index=0&id=4821b454&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4821b454",
  null
  
)

export default component.exports